// extracted by mini-css-extract-plugin
export default {"orderType":"altr1","orderType__list":"NehLH","orderType__item":"pygl2","orderType__button":"wZejI","orderType__button___checked":"rpRNc"};